module.exports = __webpack_public_path__ + "images/home/masters/law@2x-eebb5d9d77ed370631c74674c1c28afe.png";